<template>
    <card class="card">
        <div class="card-body">
            <div>
                <div class="row">
                    <div class="col-md-12">
                        <div>
                          <v-server-table
                            ref="vuetable"
                            url="/dtable/print_models"
                            :columns="columns"
                            :options="options"
                          >
                            <template slot="beforeFilter">
                              <h2>
                                <i class="fas fa-print text-primary"></i> {{$t('models.managetitle')}}
                              </h2>
                            </template>

                            <template slot="created_at" slot-scope="props">
                              {{ convertToGMT3(props.row.created_at) }}
                            </template>

                            <template slot="afterLimit">
                              <div class="form-group">
                                <button
                                  class="btn btn-block btn-primary"
                                  v-b-modal.addModel
                                  @click="openModal()"
                                >
                                  {{$t('models.button.add')}}
                                </button>

                                <b-modal
                                  id="addModel"
                                  ref="addModel"
                                  size="lg"
                                  class="card"
                                  hide-footer
                                  hide-header
                                  :title="isEditMode ? $t('text.edit') : $t('models.button.add')"
                                >
                                  <h4 class="card-title pt-0 mt-0">
                                    {{ isEditMode ? $t('text.edit') : $t('models.button.add') }}
                                  </h4>
                                  <hr />

                                  <form @submit.prevent="save" id="formAddModel">
                                    <div class="row">
                                      <div class="form-group col-md-4">
                                        <fg-input
                                          type="text"
                                          :label="$t('global.columns.name')"
                                          v-model="form.name"
                                        ></fg-input>
                                      </div>

                                      <div class="form-group col-md-4">
                                        <fg-input
                                          type="text"
                                          :label="$t('models.code')"
                                          v-model="form.code"
                                        ></fg-input>
                                      </div>

                                      <div class="form-group col-md-4">
                                        <fg-input
                                          type="text"
                                          :label="$t('models.print_limit')"
                                          v-model="form.print_limit"
                                        ></fg-input>
                                      </div>
                                    </div>

                                    <div class="row">
                                      <div class="col-md-12">
                                        <p-button type="primary" @click.native.prevent="save">
                                          {{ $t('repair.button.save') }}
                                        </p-button>
                                      </div>
                                    </div>
                                  </form>
                                </b-modal>
                              </div>
                            </template>

                            <template slot="actions" slot-scope="props" class="btn-group" role="group">
                              <button
                                class="btn btn-xs btn-primary mr-1"
                                @click="openModal(props.row)"
                              >
                                <i class="fas fa-edit fa-fw"></i>
                              </button>

                              <button
                                class="btn btn-xs btn-danger"
                                v-if="isAdmin"
                                @click="confirmDelete(props.row)"
                              >
                                <i class="fas fa-trash-alt fa-fw"></i>
                              </button>
                            </template>

                          </v-server-table>
                        </div>

                    </div>
                </div>
                <div class="clearfix"></div>
            </div>
        </div>
    </card>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      isEditMode: false,
      form: {
        name: "",
        code: "",
        print_limit: 0
      },
      columns: [
        "id",
        "name",
        "code",
        "print_limit",
        "created_at",
        "actions"
      ],
      options: {
        orderBy: {
          ascending: false,
          column: "created_at"
        },
        dateColumns: ["created_at"],
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          name: () => this.$t('global.columns.name'),
          code: () => this.$t('global.columns.code'),
          print_limit: () => this.$t('global.columns.limit'),
          created_at: () => this.$t('global.columns.createdat'),
          actions: ""
        },
        texts: {
          count: this.$t('field.count'),
          filter: this.$t('field.filter'),
          filterPlaceholder: this.$t('field.filterplaceholder'),
          limit: this.$t('field.limit'),
        },
        columnsClasses: { id: "text-right" },
        skin: "table table-sm table-hover",
        pagination: {
          edge: true
        },
        params: {}, // sem parâmetros adicionais no caso
        sortIcon: {
          base: "fas fa-sort",
          up: "fas fa-sort-up",
          down: "fas fa-sort-down",
          is: "fas fa-sort"
        }
      }
    };
  },
  computed: {
    ...mapState("models", {
      models: "all"
    }),
    ...mapState("parts", {
      parts: "parts"
    }),
    isAdmin() {
      return this.$store.getters["auth/getIsAdmin"];
    }
  },
  mounted() {
    this.$store.dispatch("parts/getAll");
  },
  methods: {
    openModal(model = null) {
      if (model) {
        // Editar
        this.isEditMode = true;
        this.form = { ...model };
      } else {
        // Novo
        this.isEditMode = false;
        this.form = { id: null, name: "", code: "", print_limit: 0 };
      }
      this.$refs.addModel.show();
    },

    async save() {
      try {
        // Atualiza o estado local
        this.$store.commit("models/set", this.form);

        // Escolhe a action conforme o modo
        const action = this.isEditMode ? "models/edit" : "models/add";

        await this.$store.dispatch(action, this.form);

        // Fecha modal e reseta formulário
        this.$refs.addModel.hide();
        this.form = { id: null, name: "", code: "", print_limit: 0 };

        // Notificação de sucesso
        this.$notify({
          type: "success",
          horizontalAlign: "center",
          message: this.isEditMode
            ? this.$t("models.message.successedit")
            : this.$t("models.message.successadd"),
        });

        // Atualiza tabela
        this.$refs.vuetable.refresh();
      } catch (error) {
        let msg = "";
        if (error?.response?.data?.errors?.length) {
          msg = error.response.data.errors[0].detail;
        } else if (error?.response?.message) {
          msg = error.response.message;
        } else {
          msg = "Erro ao salvar modelo.";
        }

        this.$notify({
          type: "danger",
          horizontalAlign: "center",
          message: msg,
        });
      }
    },

    confirmDelete(model) {
      this.$bvModal.msgBoxConfirm(
        this.$t("models.message.confirmdelete"),
        {
          title: this.$t("global.confirm"),
          size: "sm",
          okVariant: "danger",
          okTitle: this.$t("global.delete"),
          cancelTitle: this.$t("global.cancel"),
          footerClass: "p-2",
          centered: true,
        }
      ).then(value => {
        if (value) {
          this.deleteModel(model);
        }
      });
    },

    async deleteModel(model) {
      try {
        await this.$store.dispatch("models/delete", model.id);

        this.$notify({
          type: "success",
          horizontalAlign: "center",
          message: this.$t("models.message.successdelete"),
        });

        // Recarrega tabela
        this.$refs.vuetable.refresh();
      } catch (error) {
        let msg = "";
        if (error?.response?.data?.errors?.length) {
          msg = error.response.data.errors[0].detail;
        } else if (error?.response?.message) {
          msg = error.response.message;
        } else {
          msg = "Erro ao excluir modelo.";
        }

        this.$notify({
          type: "danger",
          horizontalAlign: "center",
          message: msg,
        });
      }
    },

    getCurrentDate() {
      const myDate = new Date();
      const month = ('0' + (myDate.getMonth() + 1)).slice(-2);
      const day = ('0' + myDate.getDate()).slice(-2);
      const year = myDate.getFullYear();
      return `${year}-${month}-${day}`;
    },

    export2Excel() {
      import('@/excel/Export2Excel').then(excel => {
        const tHeader = this.columns; // Cabeçalhos da tabela
        const filterVal = this.columns; // Campos a exportar
        const list = this.$refs.vuetable.data; // Dados da tabela
        const data = this.formatJson(filterVal, list);

        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: this.$t('models.export_name') + '_' + this.getCurrentDate(),
          autoWidth: true,
          bookType: 'xlsx'
        });
      });
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j =>
          j === 'created_at' ? this.convertToGMT3(v[j]) : v[j]
        )
      );
    },

    convertToGMT3(dateString) {
      if (!dateString) return "";

      const date = new Date(dateString);
      const offset = -1; // GMT-3
      date.setHours(date.getHours() + offset);

      const day = ('0' + date.getDate()).slice(-2);
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const year = date.getFullYear();
      const hours = ('0' + date.getHours()).slice(-2);
      const minutes = ('0' + date.getMinutes()).slice(-2);
      const seconds = ('0' + date.getSeconds()).slice(-2);

      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    },
    // save() {
    //   this.$store.commit("models/set", this.form);
    //   this.$store
    //     .dispatch("models/add", this.form)
    //     .then(response => {
    //       this.$bvModal.hide('addModel');
    //       this.form.name = "";
    //       this.form.code = "";
    //       this.form.print_limit = "";
    //       this.$notify({
    //         type: "success",
    //         horizontalAlign: "center",
    //         message: this.$t('models.message.successadd')
    //       });
    //     })
    //     .catch(error => {
    //       let msg = "";
    //       if (error.response.data) {
    //         msg = error.response.data.errors[0].detail;
    //       } else {
    //         msg = error.response.message;
    //       }
    //       this.$notify({
    //         type: "danger",
    //         horizontalAlign: "center",
    //         message: msg
    //       });
    //     });
    // }
  }
};
</script>
<style>
</style>
